<script>
import {mapActions, mapState} from "pinia";
import {profileStore} from "@/store/profileStore";
import {baseLoaderStore} from "@/store/baseLoaderStore";
import {authStore} from "@/store/authStore";
import {userSettingStore} from "@/store/userSettingStore";
import {takeOverStore} from "@/store/takeOverStore";
import BaseLayout from "@/components/BaseLayout.vue";
import ProfileGeneralInfo from "@/views/profile/ProfileGeneralInfo.vue";
import ProfilePoliticianInfo from "@/views/profile/ProfilePoliticianInfo.vue";
import ProfileContentInfo from "@/views/profile/ProfileContentInfo.vue";
import BaseSidebar from "@/components/BaseSidebar.vue";
import {appStore} from "@/store/appStore";
import {StructuredDataType} from "@/store/model/StructuredData";

export default {
  name: "ProfileView",
  components: {
    BaseLayout,
    ProfileGeneralInfo,
    ProfilePoliticianInfo,
    ProfileContentInfo,
    BaseSidebar
  },
  data() {
    return {
      isLoaded: false,
      memberProfileId: null,
      politicianProfileId: null,
      profileSettings: null
    }
  },
  computed: {
    ...mapState(authStore, [
        'permissionUserRole',
        'userInfo',
        'v',
        'userActiveProfile',
        'userProfiles',
        'getUserAccounts'
    ]),
    ...mapState(profileStore, [
        'profileGeneralInfo'
    ]),
    accountId() {
      return parseInt(this.$route.params.id);
    },
    ownProfile() {
      return this.isSameAccount(this.accountId);
    },
    showUserContent() {
      return true;
    }
  },
  methods: {
    ...mapActions(baseLoaderStore, [
      'hideBaseLoader'
    ]),
    ...mapActions(profileStore, [
      'getProfileGeneralInfo',
      'getMemberProfile',
      'getPoliticianProfile',
      'clearProfileInfo'
    ]),
    ...mapActions(userSettingStore,[
      'getUserSettingsAction'
    ]),
    ...mapActions(authStore, [
      'userLoggedIn',
      'isSameAccount'
    ]),
    ...mapActions(takeOverStore, [
      'initTakeOver'
    ]),
    ...mapActions(appStore, [
      'setupStructuredData',
    ]),
    initProfileView() {
      if (this.ownProfile) {
        const memberProfile = this.userProfiles.find(profile => profile.type === 'MEMBER');
        this.getMemberProfile(memberProfile.profileId);
        const politicianProfile = this.userProfiles.find(profile => profile.type === 'POLITICIAN');
        if (politicianProfile) {
          this.politicianProfileId = politicianProfile.profileId || politicianProfile.id;
          this.getPoliticianProfile(this.politicianProfileId);
        }
      } else {
        this.getUserAccounts(this.accountId).then((resp)=> {
          const memberProfile = resp.data.content[0].profiles.find(profile => profile.type === 'MEMBER');
          if (memberProfile) {
            this.memberProfileId = memberProfile.id || memberProfile.profileId;
            this.getMemberProfile(this.memberProfileId);
          }
          const politicianProfile = resp.data.content[0].profiles.find(profile => profile.type === 'POLITICIAN');
          if (politicianProfile) {
            this.politicianProfileId = politicianProfile.profileId || politicianProfile.id;
            this.getPoliticianProfile(this.politicianProfileId);
          }
        });
      }
      // TODO: valekseev: 7/16/2025: to be removed as deprecated API
      this.getProfileGeneralInfo(this.accountId).then(()=> {
        this.getUserSettingsAction(this.accountId).then((resp)=> {
          this.profileSettings = resp.data;
          this.hideBaseLoader();
          this.isLoaded = true;
        }).catch(()=> {
          this.isLoaded = true;
        });
      });

      if (localStorage.getItem("notAuthTakeOverProcess")) {
        const takeOverProcessParams = JSON.parse(localStorage.getItem("notAuthTakeOverProcess"));
        if (Number(this.$route.params.id) === takeOverProcessParams.id && this.userLoggedIn) {
          this.initTakeOver();
        }
      }
    }
  },
  beforeMount() {
    this.setupStructuredData(StructuredDataType.MEMBER, this.$route.params.id);
    this.initProfileView();
  },
  unmounted() {
    this.clearProfileInfo();
  }
}
</script>

<template>
<base-layout>
  <div v-if="isLoaded" class="user-profile-wrap">
    <profile-general-info :profile-info="profileGeneralInfo"
                          :profile-settings="profileSettings"
                          :is-own-profile="ownProfile"
    />
    <div class="d-flex justify-content-between">
      <div>
        <profile-politician-info v-if="showUserContent"
                                 :profile-id="politicianProfileId"
        />
        <profile-content-info v-if="showUserContent"
                              :is-own-profile="ownProfile"
                              :account-id="accountId"
        />
      </div>
      <base-sidebar/>
    </div>
  </div>
</base-layout>
</template>
